var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMGoldClock = function SvgMGoldClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C8.94545 40 0 30.9982 0 20.0363C0 9.07441 8.94545 0 20 0C31.0545 0 40 9.00181 40 19.9637C40 30.9256 30.9818 40 20 40Z",
    fill: "#FFE315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0656 3.93443C28.918 3.93443 36.1311 11.1475 36.1311 20C36.1311 28.8525 28.918 36.0656 20.0656 36.0656C11.2131 36.0656 4 28.8525 4 20C4 11.1475 11.1475 3.93443 20.0656 3.93443ZM20.0656 0C8.98361 0 0 8.98361 0 20C0 31.0164 8.98361 40 20 40C31.0164 40 40 31.0164 40 20C40 8.98361 31.082 0 20.0656 0Z",
    fill: "#FFAE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21 0V40C31.5279 40 40 31.0311 40 20.0327C40 8.9689 31.4656 0 21 0Z",
    fill: "#FF8200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7259 8C21.4296 8 22 8.58506 22 9.30676V21.6932C22 22.4149 21.4296 23 20.7259 23H11.2741C10.5704 23 10 22.4149 10 21.6932C10 20.9715 10.5704 20.3865 11.2741 20.3865H19.4517V9.30676C19.4517 8.58506 20.0222 8 20.7259 8Z",
    fill: "#002C3B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMGoldClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mGoldClock.9dd76c9d.svg";
export { ForwardRef as ReactComponent };